"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoLStyledRelatedArticles = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RelatedArticles = require("../../../../components/RelatedArticles");
var _RelatedArticlesCard = _interopRequireDefault(require("../../../../components/RelatedArticles/components/RelatedArticlesCard"));
var _styles = require("../../../../components/RelatedArticles/components/RelatedArticlesCard/styles");
var _typography = require("../../../../helpers/styles/typography");
var _spacing = require("../../../../helpers/styles/spacing");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LoLStyledRelatedArticles = (0, _styledComponents.default)(_RelatedArticles.RelatedArticles).withConfig({
  displayName: "styles__LoLStyledRelatedArticles",
  componentId: "sc-6py0y-0"
})(["max-width:1200px;margin:0 auto;padding:0;", "{padding-left:0;margin:0;width:100%;max-width:100%;@media ", "{width:100%;}@media ", "{width:50%;}@media ", "{width:33.33%;}", "{margin 8px auto;max-width:400px;@media ", "{margin:8px;width:auto;}}", "{height:0;padding-bottom:calc(56.25%);}.related-article-category{color:", ";", " font-size:", ";font-weight:600;letter-spacing:0.1em;}.related-article-title{margin:", " 0 0 0;line-height:1.2;font-size:", ";font-weight:bold;@media ", "{font-size:", ";}}.related-article-excerpt{margin:10px 0;font-size:", ";line-height:1.5;color:", ";}.related-article-author{display:inline-block;font-size:", ";font-weight:600;&:after{content:\"-\";display:inline-block;margin:0 0.6em;}}.related-article-published{display:inline-block;font-size:", ";font-weight:600;}}.related-article-info{margin-top:10px;padding:0 30px;@media ", "{padding:0 12px;}}"], _RelatedArticlesCard.default, function (props) {
  return props.theme.device_media.mobileXL;
}, function (props) {
  return props.theme.device_media.tablet;
}, function (props) {
  return props.theme.device_media.laptop;
}, _styles.WrapperInner, function (props) {
  return props.theme.device_media.tablet;
}, _styles.BaseRelatedArticlesImageWrapper, function (props) {
  return props.theme.color_accent;
}, _typography.uppercase, function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.sm : "12px";
}, (0, _spacing.rem)(5), function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.med : "12px";
}, function (props) {
  return props.theme.device_media.mobileXL;
}, function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.xl : "12px";
}, function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.xs : "12px";
}, function (props) {
  return props.theme.color_text_dimmed;
}, function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.xs : "12px";
}, function (props) {
  return props.theme.font_sizes ? props.theme.font_sizes.xs : "12px";
}, function (props) {
  return props.theme.device_media.mobileXL;
});
exports.LoLStyledRelatedArticles = LoLStyledRelatedArticles;